export default __webpack_public_path__ + "static/media/sandal1.5ce6f4f3.jpeg";